import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducers/index';

const store = configureStore({
  // Automatically calls `combineReducers`
  reducer
})

export default store;
